export const ADD_ERROR = "ADD_ERROR";
export const REMOVE_ERROR = "REMOVE_ERROR";

export const ADD_SUCCESS_MESSAGE = "ADD_SUCCESS_MESSAGE";
export const REMOVE_SUCCESS_MESSAGE = "REMOVE_SUCCESS_MESSAGE";

export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const SET_CURRENT_TEACHER = "SET_CURRENT_TEACHER";
export const SET_CURRENT_ADMIN = "SET_CURRENT_ADMIN";

export const SET_CURRENT_SELECTED_TEACHER = "SET_CURRENT_SELECTED_TEACHER";
export const SET_CURRENT_SELECTED_ADMIN = "SET_CURRENT_SELECTED_ADMIN";
export const SET_CURRENT_SELECTED_FACULTY = "SET_CURRENT_SELECTED_FACULTY";

export const SET_FACULTY = "SET_FACULTY";
export const GET_FACULTY_PROFILE = "GET_FACULTY_PROFILE";

export const SET_INTERNSHIPS = "SET_INTERNSHIPS";
export const SET_CURRENT_INTERNSHIP = "SET_CURRENT_INTERNSHIP";

export const SET_NOTICES = "SET_NOTICES";
export const SET_STUDENTS_NOTICES = "SET_STUDENTS_NOTICES";

//export const SET_CURRENT_SELECTED_ADMIN = "SET_CURRENT_SELECTED_ADMIN";

//export const GET_FACULTY_PROFILE="GET_FACULTY_PROFILE";
//export const SET_CURRENT_SELECTED_FACULTY="SET_CURRENT_SELECTED_FACULTY";
export const FORWARD_INTERNSHIP="FORWARD_INTERNSHIP";
export const APPROVE_INTERNSHIP="APPROVE_INTERNSHIP";


export const IDENTIFY_USER="IDENTIFY_USER";

export const UPDATE_INTERNSHIP="UPDATE_INTERNSHIP";

export const SET_CHART="SET_CHART";

export const GET_STUDENT_LIST="GET_STUDENT_LIST";

export const GET_SOME_STUDENT_LIST="GET_SOME_STUDENT_LIST";